<template>
  <b-badge
    v-if="shouldShowCompanyIndicator && companyName"
    pill
    variant="light"
    :title="companyName"
    class="active-company-pill"
    >{{ companyName }}</b-badge
  >
</template>

<script>
import { computed } from 'vue';
import State from '@/state/State';
import useCompanySwitcher from '@/state/composables/useCompanySwitcher';

// Deliberately not `<script setup>`: vue2-jest compiles SFCs through
// @vue/component-compiler-utils, which doesn't understand script setup, so a
// script-setup version of this component cannot be unit tested.
export default {
  name: 'ActiveCompanyPill',
  setup() {
    const { shouldShowCompanyIndicator } = useCompanySwitcher();

    return {
      shouldShowCompanyIndicator,
      companyName: computed(() => State.state?.company?.name),
    };
  },
};
</script>

<style lang="scss" scoped>
.active-company-pill {
  // Same pairing as SmeBadge's primary-light variant, which is the established
  // title pill (see Employee.vue). SmeBadge itself is unusable here because it
  // hard-codes width: 12rem and a company name is variable length.
  background-color: var(--palette-color-core-1-lighten-70);
  color: var(--palette-color-brand-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  // Renders in a nowrap flex row (PageSubHeader's <h1>), so shrink and ellipsise
  // rather than overflow — .page-content clips overflow-x, which would hide the
  // pill on narrow screens, exactly where the header breadcrumb is already
  // hidden. Truncating from the end keeps the distinguishing prefix
  // ("Sykes - Foundever" vs "Foundever") visible, and title has the full name.
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
